export class EffectFilters {
  state: string;
  concept:string;
  effect_type:string;
  date_from:string;
  date_to:string;
  origin:string;
  account:string;
  total_amount:number;
  total_amount_from:number;
  total_amount_to:number;

  constructor(
      state: string,
      concept:string,
      effect_type:string,
      date_from:string,
      date_to:string,
      origin:string,
      account:string,
      total_amount:number,
      total_amount_from:number,
      total_amount_to:number) {
    this.state = state;
    this.concept = concept;
    this.effect_type = effect_type;
    this.date_from = date_from;
    this.date_to = date_to;
    this.origin = origin;
    this.account = account;
    this.total_amount = total_amount;
    this.total_amount_from = total_amount_from;
    this.total_amount_to = total_amount_to;
  }
}